import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
var AgentEnumsInterface = /*#__PURE__*/function (AgentEnumsInterface) {
  AgentEnumsInterface[AgentEnumsInterface["WEB"] = 0] = "WEB";
  AgentEnumsInterface[AgentEnumsInterface["Ios"] = 1] = "Ios";
  AgentEnumsInterface[AgentEnumsInterface["Android"] = 2] = "Android";
  return AgentEnumsInterface;
}(AgentEnumsInterface || {});
var LifecycleEnum = /*#__PURE__*/function (LifecycleEnum) {
  LifecycleEnum[LifecycleEnum["ON_RESUME"] = 1] = "ON_RESUME";
  LifecycleEnum[LifecycleEnum["ON_PAUSE"] = 2] = "ON_PAUSE";
  return LifecycleEnum;
}(LifecycleEnum || {});
let NgxHybridService = /*#__PURE__*/(() => {
  class NgxHybridService {
    constructor(ngZone) {
      this.ngZone = ngZone;
      this.lifeCycleStatus = new BehaviorSubject(LifecycleEnum.ON_RESUME);
      if (this.isHybrid()) {
        this.getMarketPromise().then(market => {
          this.market = market;
        });
        this.getLifeCycleStatus();
      }
      if (this.isAndroidHybrid()) {
        window.digipayHybridApp = window.digipayHybridApp ?? {};
        window.digipayHybridApp.setPermissions = () => {};
      }
    }
    getMarketName() {
      return new Promise(resolve => {
        if (this.market) {
          resolve(this.market);
          return;
        }
        if (this.isHybrid()) {
          this.getMarketPromise().then(market => {
            this.market = market;
            resolve(this.market);
          });
        } else {
          resolve(this.market);
        }
      });
    }
    // Used for detect is your app in hybrid state or not.
    isHybrid() {
      return this.isAndroidHybrid() || this.isIosHybrid();
    }
    // Used for detect is your app in hybrid ios or not.
    isIosHybrid() {
      return Boolean(window?.webkit?.messageHandlers?.getDeviceInfo);
    }
    // Used for detect is your app in hybrid android or not.
    isAndroidHybrid() {
      return Boolean(window?.digipayHybridApp && typeof window.digipayHybridApp.getDeviceInfo === 'function');
    }
    // Used for detect platform as different agents;
    detectPlatform() {
      if (!this.isHybrid()) {
        return AgentEnumsInterface.WEB;
      }
      if (this.isAndroidHybrid()) {
        return AgentEnumsInterface.Android;
      }
      if (this.isIosHybrid()) {
        return AgentEnumsInterface.Ios;
      }
    }
    setOtpCode() {
      return new Promise((resolve, reject) => {
        try {
          window.digipayHybridApp = window.digipayHybridApp ?? {};
          window.digipayHybridApp.setOtpCode = otp => {
            resolve(otp);
          };
          window.digipayHybridApp.getOtpCode();
        } catch (e) {
          console.error(e);
          reject(e);
        }
      });
    }
    // For handle payment redirectUrl in hybrid
    setPaymentUrl(paymentType, resultUrl, withOrigin) {
      if (this.isHybrid()) {
        return this.hybridPaymentUrl(paymentType, resultUrl);
      }
      return this.paymentCallbackUrl(paymentType, resultUrl, withOrigin);
    }
    paymentCallbackUrl(paymentType, resultUrl, withOrigin = true) {
      const location = window.location.origin;
      return (withOrigin ? location : '') + resultUrl + paymentType;
    }
    hybridPaymentUrl(paymentType, resultUrl) {
      const location = window.location.origin.replace(/(^\w+:|^)\/\//, '');
      return 'dgp://' + location + resultUrl + paymentType;
    }
    // used for get market name from android.
    getMarketPromise() {
      return new Promise((resolve, reject) => {
        try {
          if (this.isAndroidHybrid()) {
            window.digipayHybridApp = window.digipayHybridApp ?? {};
            window.digipayHybridApp.setMarketName = market => {
              this.ngZone.run(() => {
                resolve(market);
              });
            };
            window.digipayHybridApp.getMarketName();
            return;
          }
          if (this.isIosHybrid()) {
            window.iosWebViewHandler = window.iosWebViewHandler ?? {};
            window.iosWebViewHandler.setMarketName = market => {
              this.ngZone.run(() => {
                resolve(market);
              });
            };
            window.webkit.messageHandlers.getMarketName.postMessage('');
          }
        } catch (e) {
          console.error(e);
          reject(e);
        }
      });
    }
    // Used for get contact from hybrid platform for ios and android.
    getContactInfo() {
      return new Promise((resolve, reject) => {
        try {
          if (this.isAndroidHybrid()) {
            window.digipayHybridApp = window.digipayHybridApp ?? {};
            window.digipayHybridApp.setContact = (phoneNumber, contactName) => {
              this.ngZone.run(() => {
                resolve({
                  phoneNumber,
                  contactName
                });
              });
            };
            window.digipayHybridApp.getContact();
            return;
          }
          if (this.isIosHybrid()) {
            window.iosWebViewHandler = window.iosWebViewHandler ?? {};
            window.iosWebViewHandler.setContact = (phoneNumber, contactName) => {
              this.ngZone.run(() => {
                resolve({
                  phoneNumber,
                  contactName
                });
              });
            };
            window.webkit.messageHandlers.getContact.postMessage('');
          }
        } catch (e) {
          console.error(e);
          reject(e);
        }
      });
    }
    getLifeCycleStatus() {
      try {
        if (this.isAndroidHybrid()) {
          window.digipayHybridApp = window.digipayHybridApp ?? {};
          window.digipayHybridApp.setCurrentLifeCycle = lifeCycleStatus => {
            this.lifeCycleStatus.next(lifeCycleStatus ?? null);
          };
        }
        if (this.isIosHybrid()) {
          window.iosWebViewHandler = window.iosWebViewHandler ?? {};
          window.iosWebViewHandler.setCurrentLifeCycle = lifeCycleStatus => {
            this.lifeCycleStatus.next(lifeCycleStatus ?? null);
          };
        }
      } catch (e) {
        console.error(e);
      }
      return this.lifeCycleStatus.asObservable();
    }
    getPermissions(permissionsList) {
      return new Promise((resolve, reject) => {
        try {
          if (this.isAndroidHybrid()) {
            window.digipayHybridApp = window.digipayHybridApp ?? {};
            window.digipayHybridApp.setPermissions = permissionList => {
              if (Array.isArray(permissionList)) {
                resolve(permissionList);
                return;
              }
              resolve(permissionList.split(",").map(Number));
            };
            window.digipayHybridApp.getPermissions(permissionsList);
            return;
          }
          if (this.isIosHybrid()) {
            window.iosWebViewHandler = window.iosWebViewHandler ? window.iosWebViewHandler : {};
            window.iosWebViewHandler.setPermissions = permissionList => {
              if (Array.isArray(permissionList)) {
                resolve(permissionList);
                return;
              }
              resolve(permissionList.split(",").map(Number));
            };
            window.webkit.messageHandlers.getPermissions.postMessage(permissionsList);
          }
        } catch (e) {
          console.error(e);
          reject(e);
        }
      });
    }
    // Checks the current status of a native device permission (e.g., camera, location)
    checkPermissions() {
      return new Promise((resolve, reject) => {
        try {
          if (this.isAndroidHybrid() && typeof window.digipayHybridApp.checkPermissions === 'function') {
            window.digipayHybridApp = window.digipayHybridApp ?? {};
            window.digipayHybridApp.setPermissions = permissionList => {
              if (Array.isArray(permissionList)) {
                resolve(permissionList);
                return;
              }
              resolve(permissionList.split(",").map(Number));
            };
            window.digipayHybridApp.checkPermissions();
            return;
          }
          if (this.isIosHybrid() && window?.webkit?.messageHandlers?.checkPermissions) {
            window.iosWebViewHandler = window.iosWebViewHandler ? window.iosWebViewHandler : {};
            window.iosWebViewHandler.setPermissions = permissionList => {
              if (Array.isArray(permissionList)) {
                resolve(permissionList);
                return;
              }
              resolve(permissionList.split(",").map(Number));
            };
            window.webkit.messageHandlers.checkPermissions.postMessage('');
          }
        } catch (e) {
          console.error(e);
          reject(e);
        }
      });
    }
    // This method used for open urls in hybrid
    openUrlInHybrid(url, hasCloseActionInAndroid = true) {
      if (this.isIosHybrid()) {
        this.openUrl(url);
        return;
      }
      if (this.isAndroidHybrid()) {
        this.openUrlInAndroid(url, hasCloseActionInAndroid);
        return;
      }
    }
    openUrlInAndroid(url, hasCloseAction) {
      window.digipayHybridApp.openUrlInAndroid(url, hasCloseAction);
    }
    // Used for tell to ios open url.
    openUrl(url) {
      window.webkit.messageHandlers.openUrl.postMessage(url);
    }
    // Used for tell native apps to close app.
    closeApp() {
      if (this.isAndroidHybrid()) {
        window.digipayHybridApp.closeApp();
        return;
      }
      if (this.isIosHybrid() && window?.webkit?.messageHandlers?.closeApp) {
        window.webkit.messageHandlers.closeApp.postMessage('');
      }
    }
    // Used for share text in android.
    shareText(text) {
      if (window.digipayHybridApp && typeof window.digipayHybridApp.shareText === 'function') {
        window.digipayHybridApp.shareText(text);
      }
    }
    // Used for share image in android.
    shareScreenImage(trackingCode = '') {
      if (window.digipayHybridApp && typeof window.digipayHybridApp.shareScreenImage === 'function') {
        window.digipayHybridApp.shareScreenImage(trackingCode);
      }
    }
    // Used for get dynamic password from android, ex: c2c dynamic password.
    getDynamicPassword() {
      return new Promise((resolve, reject) => {
        try {
          window.digipayHybridApp = window.digipayHybridApp ?? {};
          window.digipayHybridApp.setDynamicPassword = code => {
            resolve(code);
          };
          window.digipayHybridApp.getDynamicPassword();
        } catch (e) {
          console.error(e);
          reject(e);
        }
      });
    }
    // Used close web-view(like redirect to external links).
    close() {
      if (this.isAndroidHybrid()) {
        window.digipayHybridApp.close();
        return;
      }
      if (this.isIosHybrid()) {
        window.webkit.messageHandlers.close.postMessage('');
      }
    }
    goToAction(featureAction) {
      if (this.isAndroidHybrid()) {
        window.digipayHybridApp.goToAction(featureAction);
        return;
      }
      if (this.isIosHybrid()) {
        window.webkit.messageHandlers.goToAction.postMessage(featureAction);
      }
    }
    // Ask if the device supports biometrics and has biometric features
    checkBiometricAvailability() {
      return new Promise((resolve, reject) => {
        try {
          if (this.isAndroidHybrid() && typeof window.digipayHybridApp.checkBiometricAvailability === 'function') {
            window.digipayHybridApp = window.digipayHybridApp ?? {};
            window.digipayHybridApp.setBiometricAvailability = result => {
              resolve(result);
            };
            window.digipayHybridApp.checkBiometricAvailability();
            return;
          }
          if (this.isIosHybrid() && window?.webkit?.messageHandlers?.checkBiometricAvailability) {
            window.iosWebViewHandler = window.iosWebViewHandler ?? {};
            window.iosWebViewHandler.setBiometricAvailability = result => {
              resolve(result);
            };
            window.webkit.messageHandlers.checkBiometricAvailability.postMessage('');
            return;
          }
          resolve(false);
        } catch (e) {
          console.error(e);
          reject(e);
        }
      });
    }
    // Getting the biometric authentication result
    authenticateBiometric() {
      return new Observable(observer => {
        try {
          if (this.isAndroidHybrid() && typeof window.digipayHybridApp.authenticateBiometric === 'function') {
            window.digipayHybridApp = window.digipayHybridApp ?? {};
            window.digipayHybridApp.setBiometricResult = result => {
              observer.next(result);
              if (result) {
                observer.complete();
              }
            };
            window.digipayHybridApp.authenticateBiometric();
            return;
          }
          if (this.isIosHybrid() && window?.webkit?.messageHandlers?.authenticateBiometric) {
            window.iosWebViewHandler = window.iosWebViewHandler ?? {};
            window.iosWebViewHandler.setBiometricResult = result => {
              observer.next(result);
              if (result) {
                observer.complete();
              }
            };
            window.webkit.messageHandlers.authenticateBiometric.postMessage('');
            return;
          }
          observer.next(false);
          observer.complete();
        } catch (e) {
          console.error(e);
          observer.error(e);
          observer.complete();
        }
      });
    }
    // Delivering the user's PIN to native and getting the result from it
    setPin(pin) {
      return new Promise((resolve, reject) => {
        try {
          if (this.isAndroidHybrid() && typeof window.digipayHybridApp.setPin === 'function') {
            window.digipayHybridApp = window.digipayHybridApp ?? {};
            window.digipayHybridApp.onSetPinResult = result => {
              resolve(result);
            };
            window.digipayHybridApp.setPin(pin);
            return;
          }
          if (this.isIosHybrid() && window?.webkit?.messageHandlers?.setPin) {
            window.iosWebViewHandler = window.iosWebViewHandler ?? {};
            window.iosWebViewHandler.onSetPinResult = result => {
              resolve(result);
            };
            window.webkit.messageHandlers.setPin.postMessage(pin);
            return;
          }
          resolve(false);
        } catch (e) {
          console.error(e);
          reject(e);
        }
      });
    }
    // Getting the PIN from native and its result.
    getPin() {
      return new Promise((resolve, reject) => {
        try {
          if (this.isAndroidHybrid() && typeof window.digipayHybridApp.getPin === 'function') {
            window.digipayHybridApp = window.digipayHybridApp ?? {};
            window.digipayHybridApp.onGetPinResult = result => {
              resolve(result);
            };
            window.digipayHybridApp.getPin();
            return;
          }
          if (this.isIosHybrid() && window?.webkit?.messageHandlers?.getPin) {
            window.iosWebViewHandler = window.iosWebViewHandler ?? {};
            window.iosWebViewHandler.onGetPinResult = result => {
              resolve(result);
            };
            window.webkit.messageHandlers.getPin.postMessage('');
            return;
          }
          reject();
        } catch (e) {
          console.error(e);
          reject(e);
        }
      });
    }
    // Remove pin and get result.
    removePin() {
      return new Promise((resolve, reject) => {
        try {
          if (this.isAndroidHybrid() && typeof window.digipayHybridApp.removePin === 'function') {
            window.digipayHybridApp = window.digipayHybridApp ?? {};
            window.digipayHybridApp.onRemovePinResult = result => {
              resolve(result);
            };
            window.digipayHybridApp.removePin();
            return;
          }
          if (this.isIosHybrid() && window?.webkit?.messageHandlers?.removePin) {
            window.iosWebViewHandler = window.iosWebViewHandler ?? {};
            window.iosWebViewHandler.onRemovePinResult = result => {
              resolve(result);
            };
            window.webkit.messageHandlers.removePin.postMessage('');
            return;
          }
          resolve(false);
        } catch (e) {
          console.error(e);
          reject(e);
        }
      });
    }
    requestToEnableGps() {
      return new Promise((resolve, reject) => {
        try {
          if (this.isAndroidHybrid() && typeof window.digipayHybridApp.requestToEnableGps === 'function') {
            window.digipayHybridApp = window.digipayHybridApp ?? {};
            window.digipayHybridApp.setGPSStatus = result => {
              resolve(result);
            };
            window.digipayHybridApp.requestToEnableGps();
            return;
          }
          resolve(false);
        } catch (e) {
          console.error(e);
          reject(e);
        }
      });
    }
    enableScreenshot() {
      try {
        if (this.isAndroidHybrid() && typeof window.digipayHybridApp.enableScreenshot === 'function') {
          window.digipayHybridApp.enableScreenshot();
        }
      } catch (e) {
        console.error(e);
      }
    }
    disableScreenshot() {
      try {
        if (this.isAndroidHybrid() && typeof window.digipayHybridApp.disableScreenshot === 'function') {
          window.digipayHybridApp.disableScreenshot();
        }
      } catch (e) {
        console.error(e);
      }
    }
    // For get hybrid version from native (Api and version app).
    getHybridVersion() {
      return new Promise((resolve, reject) => {
        try {
          if (this.isAndroidHybrid() && typeof window.digipayHybridApp.getHybridVersion === 'function') {
            window.digipayHybridApp = window.digipayHybridApp ?? {};
            window.digipayHybridApp.setHybridVersion = hybridVersion => {
              resolve(hybridVersion);
            };
            window.digipayHybridApp.getHybridVersion();
            return;
          }
        } catch (e) {
          console.error(e);
          reject(e);
        }
      });
    }
    static {
      this.ɵfac = function NgxHybridService_Factory(t) {
        return new (t || NgxHybridService)(i0.ɵɵinject(i0.NgZone));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: NgxHybridService,
        factory: NgxHybridService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return NgxHybridService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var PermissionListEnum = /*#__PURE__*/function (PermissionListEnum) {
  PermissionListEnum[PermissionListEnum["CAMERA"] = 2000] = "CAMERA";
  PermissionListEnum[PermissionListEnum["CONTACT"] = 2010] = "CONTACT";
  PermissionListEnum[PermissionListEnum["AUDIO"] = 2020] = "AUDIO";
  PermissionListEnum[PermissionListEnum["LOCATION"] = 2030] = "LOCATION";
  PermissionListEnum[PermissionListEnum["IMEI"] = 2040] = "IMEI";
  PermissionListEnum[PermissionListEnum["DOWNLOAD_FILE"] = 2050] = "DOWNLOAD_FILE";
  return PermissionListEnum;
}(PermissionListEnum || {});
var HybridActionEnumsModel = /*#__PURE__*/function (HybridActionEnumsModel) {
  HybridActionEnumsModel[HybridActionEnumsModel["APP_SETTING"] = 1000] = "APP_SETTING";
  return HybridActionEnumsModel;
}(HybridActionEnumsModel || {});
/*
 * Public API Surface of ngx-hybrid-service
 */

/**
 * Generated bundle index. Do not edit.
 */

export { LifecycleEnum as AndroidLifecycle, HybridActionEnumsModel, NgxHybridService, NgxHybridService as NgxHybridServiceService, PermissionListEnum };
